import { EmoticonPoopOutlineIcon } from './EmoticonPoopOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 1E402C80-69DB-432F-BB0F-C05ACB6A7839
 * name emoticon-poop-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-poop-outline.svg
 * tags
 * - Emoji 
 */
export const EmojiPoopOutlineIcon = EmoticonPoopOutlineIcon;
export default EmojiPoopOutlineIcon